import {
  handleKeyDown,
  getItem,
  getSinglePurches,
  getFloorAll,
  updateTransaction,
  createStoreTransaction,
  getSingleTransaction,
  getSingleMasterFloor,
} from "_services";

import { CommonDate, CommonInput, CustomSelect, Heading } from "components";
import { BasicExample } from "components/common/CommonModal/CommonModal";
import { errorSchema, utils } from "helper";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { Images } from "constants";

const AddStockTransaction = () => {
  const initi = {
    floor: "",
    transaction_date: new Date(),
    person_name: "",
    person_mobile: "",
    remarks: "",
  };

  const itemObj = {
    item: "",
    quantity: 0,
  };

  const navigate = useNavigate();
  const { id, eventView } = useParams();
  const eventRef = useRef(null);
  const mobileRef = useRef(null);
  const nameRef = useRef(null);
  const genderRef = useRef(null);
  const stateRef = useRef(null);
  const [form, setForm] = useState(initi);
  const [initialForm, setInitialForm] = useState(initi);
  const [formError, setFormError] = useState("");
  const [allBuyerList, setAllBuyerList] = useState([]);
  const [allItemList, setAllItemList] = useState([]);
  const [itemList, setItemList] = useState([itemObj]);
  const [initialItemList, setInitialItemList] = useState([itemObj]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  //   useEffect(() => {
  //     if (mobileRef.current) {
  //       nameRef.current.focus();
  //     }
  //   }, []);

  useEffect(() => {
    getBuyerList();
    getItemList();
  }, []);

  useEffect(() => {
    if (id) {
      getPurchaseDetails(id);
    }
  }, [id]);

  useEffect(() => {
    if (form?.floor) {
      getFloorDetails(form?.floor);
    }
  }, [form?.floor]);


  const getPurchaseDetails = async (id) => {
    try {
      const res = await getSingleTransaction(id);
      if (res?.status === 200) {
      
        const eventData = {
        
          floor: res?.results?.floor,
          transaction_date: res?.results?.transaction_date,
          person_name: res?.results?.person_name,
          person_mobile: res?.results?.person_mobile,
          remarks: res?.results?.remarks,
         
        };
        const list = res?.results?.transaction_items?.map((i) => {
          return {
            item: i?.item,
            quantity: i?.quantity,
          };
        });
        setSelectedItems(res?.results?.transaction_items?.map((i)=>i?.item))
        setItemList(list);
        setForm(eventData);
        setInitialForm(eventData);
      }
    } catch (error) {}
  };

  const getFloorDetails = async (id) => {
    try {
      const res = await getSingleMasterFloor(id);
      if (res?.status === 200) {
        
        const eventData = {
         
          person_name: res?.results?.supervisor_name,
          person_mobile: res?.results?.supervisor_mobile_number,
        };
        
        setForm(eventData);
        setInitialForm(eventData);
      }
    } catch (error) {}
  };

  const getBuyerList = async (url = "") => {
    try {
      const res = await getFloorAll(url);

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllBuyerList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const getItemList = async (url = "") => {
    try {
      const buyerFilter = {
        limit:"all"
      }
      const filterParams = new URLSearchParams();
      Object.keys(buyerFilter).forEach((key) => {
        if (buyerFilter[key]) {
          filterParams.append(key, buyerFilter[key]);
        }
      });

      const urlmodify = `${url}?${filterParams.toString()}`;
      const res = await getItem(url,filterParams.toString());

      if (res?.status === 200) {
        const list = res?.results?.map((i) => {
          return {
            ...i,
            label: i?.name,
            value: i?.id,
          };
        });
        setAllItemList(list);
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.transactionSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const convertToISOFormat = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString();
  };

  const handleSubmit = async () => {
    try {
      // Validate form and return if errors are present
      const validationResult = await utils?.checkFormError(
        { ...form, itemArray: itemList },
        errorSchema.transactionSchema
      );

      if (validationResult !== true) {
        setFormError(validationResult);
        return;
      }

      const changedPayload = buildChangedPayload();

      if (Object.keys(changedPayload).length === 0) {
        console.log("No changes detected.");
        return;
      }

      setIsLoading(true);

      // Submit booking update or creation
      if (Object.keys(changedPayload).length !== 0) {
        const bookingResponse = id
          ? await updateTransaction({ payload: { ...form ,transaction_date:new Date(), transaction_items: itemList }, id })
          : await createStoreTransaction({ ...form, transaction_items: itemList });

        handleBookingResponse(bookingResponse);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Submission error:", error);
    }
  };

  // Helper function to build changed payload for booking details
  const buildChangedPayload = () => {
    const payload = {};

    const fieldsToCheck = ["buyer", "purchase_date", "purchase_bill_number"];
    fieldsToCheck.forEach((field) => {
      if (form[field] !== initialForm[field]) {
        payload[field] = form[field];
      }
      payload.items = itemList;
      payload.purchase_date = utils.formatDate(form?.purchase_date);
    });

    return payload;
  };

  const handleBookingResponse = (response) => {
    setIsLoading(false);
    if (response?.status === 200 || response?.status === 201) {
      toast.success(response.message);
      navigate("/store/stock_transaction");
    } else {
     
    }
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef && nextInputRef.current) {
        nextInputRef.current.focus();
      } else {
        handleSubmit(e);
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  const addItemInput = (e) => {
    e.preventDefault();

    setItemList((preState) => {
      return [...preState, itemObj];
    });
  };

  const removeFromInput = (index) => {
    const newItemIput = [...itemList];
    newItemIput.splice(index, 1);
    setItemList(newItemIput);
  };

  const handleInputChange = async (value, index, name) => {
    const newItem = [...itemList];
    newItem[index][name] = value;
    setItemList(newItem);
    setSelectedItems((prevSelected) => ({
      ...prevSelected,
      [index]: value, 
    }));

    if (formError) {
      if (`${formError}${[index]}${[name]}`) {
        const validationResult = await utils.checkFormError(
          { ...form, itemArray: itemList },
          errorSchema.transactionSchema
        );

        if (validationResult === true) {
          const newFormError = { ...formError };
          if (newFormError.itemArray && newFormError.itemArray[index]) {
            delete newFormError.itemArray[index][name];
            if (Object.keys(newFormError.itemArray[index]).length === 0) {
              delete newFormError.itemArray[index];
            }
          }
          setFormError(newFormError);
        } else {
          setFormError(validationResult);
        }
      }
    }
  };

  return (
    <div>
      <Heading title={id ? "Edit Stock Transaction" : "Add Stock Transaction"} />
      <div className="_addContainer bg-[#FBF9FB]">
        <div className="_midCont_body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-10">
                <div className="_crtDisp_listBx">
                  <div className="">
                    <h4 className="_disPatch_heads">Basic Details</h4>
                    <div className="_fleX_inds">
                      <div className="_divForth">
                        <CustomSelect
                          placeholder="Select Floor"
                          label="Floor"
                          options={allBuyerList}
                          onSelect={(data) => {
                            handleOnChange("floor", data.value);
                          }}
                          focus={
                            !!(
                              typeof formError === "object" && formError?.floor
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.floor
                              : ""
                          }
                          value={allBuyerList?.find(
                            (i) => i?.id === form?.floor
                          )}
                          ref={eventRef}
                          enableSearch={true}
                        //   onEnterSelect={() => mobileRef.current.focus()}
                          disabled={eventView}
                        />
                      </div>
                      <div className="_divForth">
                        <CommonInput
                          type="text"
                          placeholder="Enter Person Name"
                          label="Person Name"
                          name="person_name"
                          value={form?.person_name}
                          focus={
                            !!(
                              typeof formError === "object" &&
                              formError?.person_name
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.person_name
                              : ""
                          }
                          onChange={({ target: { name, value } }) =>
                            handleOnChange(name, value)
                          }
                          ref={nameRef}
                        //   onKeyDown={(e) => handleKey(e, genderRef)}
                          disabled={eventView}
                        />
                      </div>
                      <div className="_divForth">
                        <CommonInput
                          type="text"
                          placeholder="Enter Mobile Number"
                          label="Mobile Number"
                          name="person_mobile"
                          // borderStyle={"borderStyle"}
                          value={form?.person_mobile}
                          focus={
                            !!(
                              typeof formError === "object" &&
                              formError?.person_mobile
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.person_mobile
                              : ""
                          }
                          onChange={({ target: { name, value } }) =>
                            handleOnChange(name, value)
                          }
                          maxLength={10}
                          ref={mobileRef}
                        //   onKeyDown={(e) => handleKey(e, nameRef)}
                          disabled={eventView}
                          onKeyPress={handleKeyDown}
                          helpText="Mobile Number Without +91"
                        
                        />
                      </div>
                      <div className="_divForth">
                        <CommonInput
                          type="text"
                          placeholder="Enter Remark"
                          label="Remark"
                          name="remarks"
                          value={form?.remarks}
                          focus={
                            !!(
                              typeof formError === "object" &&
                              formError?.remarks
                            )
                          }
                          error={
                            !!(typeof formError === "object")
                              ? formError?.remarks
                              : ""
                          }
                          onChange={({ target: { name, value } }) =>
                            handleOnChange(name, value)
                          }
                          ref={nameRef}
                        //   onKeyDown={(e) => handleKey(e, genderRef)}
                          disabled={eventView}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <h4 className="_disPatch_heads">Items Details</h4>
                    <div className="_fleX_inds">
                      {itemList?.map((data, index) => {
                        return (
                          <>
                            <div className="_divForth">
                              <CustomSelect
                                placeholder="Select Item"
                                label="Item"
                                // options={allItemList}
                                options={allItemList.filter(
                                  (item) => !Object.values(selectedItems).includes(item.value) // Remove all selected values
                                )}
                                onSelect={(data) => {
                                  handleInputChange(
                                    data?.value,
                                    index,
                                    "item"
                                  );
                                }}
                                focus={formError[`itemArray[${index}].item`]}
                                error={formError[`itemArray[${index}].item`]}
                                value={
                                  data?.item
                                    ? allItemList?.find(
                                        (i) => i?.value === data?.item
                                      )
                                    : { label: "", value: "" }
                                }
                                
                                ref={genderRef}
                                enableSearch={true}
                                // onEnterSelect={() => stateRef.current.focus()}
                                disabled={eventView}
                              />
                            </div>
                            <div className="_divForth">
                              <CommonInput
                                type="text"
                                placeholder="Enter Quantity"
                                label="Quantity"
                                name="quantity"
                                // borderStyle={"borderStyle"}
                                value={data?.quantity}
                                focus={
                                  formError[`itemArray[${index}].quantity`]
                                }
                                error={
                                  formError[`itemArray[${index}].quantity`]
                                }
                                onChange={({ target: { name, value } }) => {
                                  handleInputChange(value, index, name);
                                }}
                                ref={mobileRef}
                                // onKeyDown={(e) => handleKey(e, nameRef)}
                                disabled={eventView}
                                onKeyPress={handleKeyDown}
                              />
                            </div>
                            
                            <div className="_divForth">
                              {itemList?.length > 1 && (
                                <div
                                  className="delete_btn"
                                  // style={{ width: "100px", marginTop: "15px" }}
                                  onClick={() => removeFromInput(index)}
                                >
                                  <div className="_listbtn">
                                    {" "}
                                    <button
                                      className="_del_pl"
                                      onClick={() => removeFromInput(index)}
                                      disabled={eventView}
                                    >
                                      <img
                                        src={Images.DELETEICON.default}
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="_divForth">
                              
                            </div>
                          </>
                        );
                      })}

                      <div className="_divForth">
                        <div
                          className="_anvSwitcherNew form-check form-switch"
                          style={{ width: "150px", marginTop: "10px" }}
                        >
                          <div className="_listbtn">
                            <button
                              className="_addComm_btn _builtyPrintBtn"
                              onClick={addItemInput}
                              disabled={eventView}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottomFix">
        <button
          className="_addComm_btn"
          type="button"
          onClick={() => handleSubmit()}
          disabled={isLoading || eventView}
        >
          {isLoading ? (
            <BasicExample />
          ) : id ? (
            "Update Transaction"
          ) : (
            "Add Transaction"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddStockTransaction;

export const MessageModal = ({ show, onClose, title, message }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        {title && <h3>{title}</h3>}
        <p>{message}</p>
        {onClose && <button onClick={onClose}>Close</button>}
      </div>
    </div>
  );
};
